export const form = {
    rangeOverflow: "Value should not be higher than {{max}}.",
    rangeUnderflow: "Value should not be lower than {{min}}.",
    required: "Field is required.",
    invalidEmail: "Invalid email address.",
};
